import 'whatwg-fetch'
import { translate } from 'loankeeper-common/helpers'

import { printReport } from '../../../store/printReport'
import { types, hashNames, PRINT_URL } from './constants'
import { fetchPrintUrl } from './fetch'
import { getBackendUrl } from '../../../store/config'

export const openReport = (url, format) => {
  if (format === 'RTF') {
    window.location = url
  } else {
    window.open(url, '', 'width=900,height=800')
  }
}

const sendToPrint = async (blob) => {
  let result = false

  try {
    await fetchPrintUrl(PRINT_URL, blob)

    result = true
  } catch (e) {
    result = false
  }
  return result
}

export const handlePrint = async (url, direct, format) => {
  let result = false
  if (direct) {
    const response = await fetch(url)
    const blob = await response.blob()
    if (blob) {
      const reader = new FileReader()

      await new Promise((resolve) => {
        reader.addEventListener(
          'load',
          () => {
            const data = reader.result.toString().replace('data:application/fp3;base64,', '')

            result = sendToPrint(data)

            resolve()
          },
          false,
        )

        reader.readAsDataURL(blob)
      })
    }
  } else {
    openReport(url, format)
    return true
  }
  return result
}

export const translateLKMessage = (name) => translate(`LKMESSAGE-${name}`)
export const translateWebMessage = (name) => translate(`frm_web_messages-${name}`)

const generateDropDownParams = (type, { ID, hash, extraID, extraHash }) => {
  switch (type) {
    case types.application:
      return {
        AppID: ID,
        HashSum_AppID_: hash,
      }

    case types.loan:
      return {
        LoanID: ID,
        HashSum_LoanID_: hash,
      }

    case types.loanCalculator:
      return {
        DemoScheduleSequenceID: ID,
        HashSum_DemoScheduleSequenceID_: hash,
      }

    case types.loanCollateral:
      return {
        LoanID: ID,
        HashSum_LoanID_: hash,
        CollateralID: extraID,
        HashSum_CollateralID_: extraHash,
      }

    case types.client:
      return {
        ClientID: ID,
        HashSum_ClientID_: hash,
      }

    // TODO: review why app is not included in types
    // case types.app:
    //   return {
    //     AppID: ID,
    //     HashSum_AppID_: hash,
    //   }

    case types.collateral:
      return {
        CollateralID: ID,
        HashSum_CollateralID_: hash,
      }

    case types.account:
      return {
        AccountID: ID,
        HashSum_AccountID_: hash,
      }

    case types.entry:
      return {
        EntryID: ID,
        HashSum_EntryID_: hash,
      }

    case types.entryConvert:
      return {
        OID: ID,
        HashSum_OID_: hash,
      }

    case types.collateralMng:
      return {
        CMSessionID: ID,
        HashSum_CMSessionID_: hash,
      }

    case types.reporting:
      return {
        ReportID: ID,
        HashSum_ReportID_: hash,
      }

    default:
      return {}
  }
}

const generatePrintPDFUrl = (type, args, openError) => async (dispatch, getState) => {
  const backendUrl = getBackendUrl(getState())

  let requiredParams = generateDropDownParams(type, args)

  const hashName = hashNames[type]

  let response

  if (args.HashSum_PrintReportIDOID_ && type === 'entry') {
    requiredParams = {}
  }

  try {
    response = await dispatch(
      printReport({
        params: {
          PrintReportID: args.PrintReportID,
          [hashName]: args.printReportHash,
          page: args.page,
          Format: args.direct ? 'FP3' : args.format,
          ...requiredParams,
          HashSum_PrintReportIDOID_: args.HashSum_PrintReportIDOID_,
          ...args.extraParams,
        },
        body: args.body,
      }),
    )
  } catch (e) {
    if (e.Error && e.Error.Text === 'ERR_NO_SERVERS_AVAILABLE') {
      try {
        response = await new Promise((resolve, reject) => {
          setTimeout(() => {
            dispatch(
              printReport({
                params: {
                  PrintReportID: args.PrintReportID,
                  [hashName]: args.printReportHash,
                  page: args.page,
                  Format: args.direct ? 'FP3' : undefined,
                  ...requiredParams,
                  ...args.extraParams,
                },
              }),
            ).then(resolve, reject)
          }, 1000)
        })
      } catch (error) {
        if (openError) {
          openError(translateWebMessage(e.Error.Message || e.Error.Text))
          return
        }

        throw e
      }
    } else {
      if (openError) {
        openError(translateWebMessage(e.Error.Message || e.Error.Text))
        return
      }

      throw e
    }
  }

  const queryParams = {
    FName: response.payload.FileName,
    ServerID: response.payload.ServerID,
  }

  const queryStr = Object.keys(queryParams)
    .map((key) => `${key}=${encodeURIComponent(queryParams[key])}`)
    .join('&')

  return `${backendUrl}/getpdf_api.php?${queryStr}`
}

export { generateDropDownParams, generatePrintPDFUrl }
